import React from "react";
import { makeStyles } from "@material-ui/core";
import TopBar from "./TopBar";
import AppBar from "./AppBar";

interface styleProps {
  showDrawer?: boolean;
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: "flex",
    height: "100%",
    overflow: "hidden",
    width: "100%",
  },
  wrapper: (props: styleProps) => {
    return {
      display: "flex",
      flex: "1 1 auto",
      overflow: "hidden",
      paddingTop: 0,
      paddingLeft: props.showDrawer ? 256 : 0,
    };
  },
  contentContainer: (props: styleProps) => {
    return {
      display: "flex",
      flex: "1 1 auto",
      overflow: "hidden",
      paddingTop: props.showDrawer ? 0 : 84,
      height: props.showDrawer ? "100vh" : "calc(100vh)",
    };
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflowY: "scroll",
  },
}));

const LandingLayout: React.FC = ({ children }) => {
  const classes = useStyles({
    showDrawer: false,
  });

  return (
    <div className={classes.root}>
      <TopBar />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content} id="layout-wrapper">
            {children}
          </div>
        </div>
      </div>
      <AppBar />
    </div>
  );
};

export default LandingLayout;
